import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import App from './App';
import './index.css';

(window as any).axios = axios;

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [new BrowserTracing()],
    environment: process.env.NODE_ENV || 'development',
    tracesSampleRate: Number(process.env.REACT_APP_SENTRY_SAMPLE_RATE),
    ignoreErrors: [`Cannot read property 'traverse' of undefined`],
  });
}

const container = document.getElementById('root');

ReactDOM.createRoot(container as Element).render(<App />);
